import React from "react";
import { TabPanel, Item } from "devextreme-react/tab-panel";

import "devextreme-react/tab-panel";
import Form from "devextreme-react/form";

type TabsProps = {
  height?: number;
  children: {
    title: string;
    component: React.ReactNode;
  }[];
  setActive?: (active: number) => void;
};

const Tabs: React.FC<TabsProps> = ({ children, setActive, height }) => {
  const itemRenderFunction = (formItem: React.ReactNode) => (
    <Form labelLocation="top" className="form-container">
      <Item render={() => formItem} />
    </Form>
  );

  return (
    <TabPanel
      height={height}
      animationEnabled
      onSelectedIndexChange={(index) => setActive && setActive(index)}
    >
      {children.map((child, i) => (
        <Item
          key={i}
          title={child.title}
          render={() => itemRenderFunction(child.component)}
        />
      ))}
    </TabPanel>
  );
};

export default Tabs;
